import { returnEditMode } from './return-edit-mode.util';

export const toggleEdit = (componentProps = {}) => {
  const toReturn = returnEditMode('toggle', componentProps);
  toReturn.labelDirection('horizontal');
  return toReturn;
};
